import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { ModalBase } from '../components/ModalBase';
import { Palette, Sizes } from '../@shared/palette';


export type ConfirmDialogProps = {
  onConfirmedAction: () => void;
  title: string;
  description?: string;
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  isConfirmDisabled?: boolean;
  isProcessing?: boolean;
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const handleSave = React.useCallback(() => {
    props.onConfirmedAction();
  }, [props]);

  return <>
    <ModalBase
      isOpen={props.isOpen}
      onCancel={props.onClose}
      onSave={handleSave}
      title={props.title}
      isDisabledSave={props.isConfirmDisabled}
      isProcessing={props.isProcessing}
      primaryBtnText='Confirm'
      secondBtnText="Decline"
    >
      <Box sx={{ margin: "20px 0" }}>
        {props.children ? props.children : <Typography sx={{ color: Palette.textColorPrimary, fontSize: Sizes.textPrimary }}>{props.description}</Typography>}
      </Box>
    </ModalBase>
  </>
}